import { CONSTANT } from '@const';
import { IssueCreation, ReportErrorItemType } from '@types';
import { getCurrentDateTime } from '@utils';
import { v4 as uuidv4 } from 'uuid';

import { ApiParams, ApiService } from '../api/ApiService';

export class ReportIssueService extends ApiService {
	static readonly faultyDeviceIssue = {
		value: 'Faulty Device Report',
		label: 'Device is faulty',
	};

	static async createReportIssue(issueCreation: IssueCreation): Promise<void> {
		const payload: ReportErrorItemType = this.newIssuePayload(issueCreation);
		const params: ApiParams = {
			method: 'POST',
			url: CONSTANT.REPORT_API_URL,
			data: payload,
		};
		return await this.executeApiRequest(params);
	}

	private static newIssuePayload(issueCreation: IssueCreation): ReportErrorItemType {
		return {
			id: uuidv4(),
			userID: this.getUserId(),
			reportDate: getCurrentDateTime(),
			message: issueCreation.message,
			field: this.mapIssueField(issueCreation.field),
			entity: {
				entityType: issueCreation.entityType,
				...(issueCreation.entityId && {
					entityID: issueCreation.entityId,
				}),
			},
		};
	}

	private static mapIssueField(issueCreationField?: string) {
		if (issueCreationField === this.faultyDeviceIssue.label) {
			issueCreationField = this.faultyDeviceIssue.value;
		}
		return issueCreationField;
	}
}
